import React from 'react';
import { Grid, Typography, Paper, Box, Button, TextField, Fab, useMediaQuery, styled, Drawer, Autocomplete, SxProps, Theme, MenuItem } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SearchIcon from '@mui/icons-material/Search';
import appTema from '../../servicos/mui/Theme';
import { Controller, useForm } from 'react-hook-form';
import { bananinhaListError, validacao } from '../../servicos/IFormularios';
import { IEntidadesData, IRetornoAjaxEntidades } from '../../servicos/entidades/Entidades_FrontAPI';
import OptionsController, {IOptions} from '../../servicos/forms/OptionsController';
import EntidadesController from '../../servicos/entidades/EntidadesController';
import Bananinha, { IBananinhaDelegate } from '../widgets/Bananinha';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import {filterSeriesOptions} from '../../AppConfig';
import ClearIcon from '@mui/icons-material/Clear';

export enum ETIPOFILTER
{
	USUARIOS = 'usuarios',
	PRODUTORAS = 'produtoras',
	SERIES = 'series',
	PROGRAMAS = 'programas'
}

export enum ESTATUSFILTER
{
	INICIAL = 'inicial',
	FECHADO = 'fechado',
	ABERTO = 'aberto',
}

export enum EFILTERINIT
{
	TITULO = 'titulo',
	NOME = 'displayName',
	ANO = 'anoProducao',
	ANO_INI = 'anoProducaoInicial',
	ANO_FIM = 'anoProducaoFinal',
}

export interface IPropsFilterObj
{
	titulo?: string
	anoProducao?: string
	anoProducaoInicial?: string
	anoProducaoFinal?: string
	idGenero?: string
	numeroCpb?: string
	numeroCrt?: string
	idGsatIdFrm?: string
	idSerie?: string
	displayName?: string
	email?: string
	tipoSerie?: string
	idProdutora?: string
	classificacaoEtaria?: string
	tipoPrograma?: string
	tipoMidia?: string
	vigencia?: string
	licenciamento?: string
	versao?: string
	idiomaVersao?: string
}

export const objFilterDefault =
{
	titulo: "",
	anoProducao: "",
	anoProducaoInicial: "",
	anoProducaoFinal: "",
	idGenero: "",
	numeroCpb: "",
	numeroCrt: "",
	idGsatIdFrm: "",
	idSerie: "",
	displayName: "",
	email: "",
	tipoSerie: "",
	idProdutora: "",
	classificacaoEtaria: "",
	tipoPrograma: "",
	tipoMidia: "",
	vigencia: "",
	licenciamento: "",
	versao: "",
	idiomaVersao: "",
}

type Position = 'top' | 'left' | 'bottom' | 'right';

interface IPropsFilterList
{
	filter: string
}

interface IPropsFilter
{
	sxFiltrar?: SxProps<Theme>
	tipoForm?: ETIPOFILTER
	filterList: string[]
	status: ESTATUSFILTER
	filterDefault?: IPropsFilterObj
	callback: (dataFilter:IPropsFilterObj) => void
}

const TableFilter = (props:IPropsFilter) =>
{
	const EntController = new EntidadesController();
	const OptsController = new OptionsController();

	const drawerPosition:Position = 'right';

	const isSmallScreen = useMediaQuery(appTema.breakpoints.down('md'));
	const fabSize = isSmallScreen ? 'small' : 'medium';

	const [state, setState] = React.useState({right: false});

	const [generosList, setGenerosList] = React.useState<IEntidadesData[]|[null]>(null);
	const [produtorasList, setProdutorasList] = React.useState<IEntidadesData[]|[null]>(null);
	const [seriesList, setSeriesList] = React.useState<IEntidadesData[]|[null]>(null);
	const [bananinhaDelegate, setBananinhaDelegate] = React.useState<IBananinhaDelegate|undefined>(undefined);

	const [listOptionsTipoSeries, setListOptionsTipoSeries] = React.useState<IOptions[]|[]>([]);
	const [listOptionsClassEtaria, setListOptionsClassEtaria] = React.useState<IOptions[]|[]>([]);
	const [listOptionsTipoPrograma, setListOptionsTipoPrograma] = React.useState<IOptions[]|[]>([]);
	const [listOptionsTipoMidia, setListOptionsTipoMidia] = React.useState<IOptions[]|[]>([]);
	const [listOptionsVigencia, setListOptionsVigencia] = React.useState<IOptions[]|[]>([]);
	const [listOptionsLicenciamento, setListOptionsLicenciamento] = React.useState<IOptions[]|[]>([]);
	const [listOptionsVersao, setListOptionsVersao] = React.useState<IOptions[]|[]>([]);
	const [listOptionsIdioma, setListOptionsIdioma] = React.useState<IOptions[]|[]>([]);

	React.useEffect(() =>
	{
		setListOptionsTipoSeries(OptsController.tipoSerie() as IOptions[]);
		setListOptionsClassEtaria(OptsController.classificacaoEtaria() as IOptions[]);
		setListOptionsTipoPrograma(OptsController.tipoPrograma() as IOptions[]);
		setListOptionsTipoMidia(OptsController.tipoMidia() as IOptions[]);
		setListOptionsVigencia(OptsController.vigencia() as IOptions[]);
		setListOptionsLicenciamento(OptsController.licenciamento() as IOptions[]);
		setListOptionsVersao(OptsController.versao() as IOptions[]);
		setListOptionsIdioma(OptsController.idiomaVersao() as IOptions[]);
	}, []);

	const {
		handleSubmit, control, formState: { errors }}
		= useForm<IPropsFilterObj>({reValidateMode: "onSubmit", criteriaMode: "all", shouldFocusError: false, defaultValues: props.filterDefault || objFilterDefault});

	const handleError = React.useCallback((combinedErrors) =>
	{
		bananinhaDelegate?.abrir(combinedErrors ? combinedErrors : "Erro ao tentar cadastrar", "error");
	},
	[bananinhaDelegate])

	function onSubmit(data:IPropsFilterObj)
	{
		props.callback(data)
	}

	const onInvalid = async (state: any) =>
	{
		let erroMsg = '<ul>';

		erroMsg += bananinhaListError(state);

		erroMsg += '<ul>';

		handleError(erroMsg)
	}

	const toggleDrawer = (drawerPosition: Position, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
		if (event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
			return;
		}
		setState({ ...state, [drawerPosition]: open });
	};

	const getGeneros = async () =>
	{
		try
		{
			const res:IRetornoAjaxEntidades = await EntController.generoList();

			if(res.status == 200 && res.Data?.rows?.length > 0)
				setGenerosList(res.Data.rows);
		}
		catch(e)
		{
			console.log('Error get gêneros: ' + e);
		}
	}

	const getProdutoras = async () =>
	{
		try
		{
			const res:IRetornoAjaxEntidades = await EntController.produtoraList();

			if(res.status == 200 && res.Data?.rows?.length > 0)
				setProdutorasList(res.Data.rows);
		}
		catch(e)
		{
			console.log('Error get gêneros: ' + e);
		}
	}

	const getSeries = async () =>
	{
		try
		{
			const res:IRetornoAjaxEntidades = await EntController.seriesList();

			if(res.status == 200 && res.Data?.rows?.length > 0)
				setSeriesList(res.Data.rows);
		}
		catch(e)
		{
			console.log('Error get séries: ' + e);
		}
	}

	React.useEffect(() =>
	{
		setState({right: props.status == ESTATUSFILTER.ABERTO ? true : false});
		toggleDrawer('right', props.status == ESTATUSFILTER.ABERTO ? true : false);
	},[props.status]);

	React.useEffect(() =>
	{
		if(props.tipoForm && props.tipoForm == ETIPOFILTER.SERIES)
		{
			getGeneros();
			getProdutoras();
		}

		if(props.tipoForm && props.tipoForm == ETIPOFILTER.PROGRAMAS)
			getSeries();
	},[]);

	return <>
		<Bananinha getDelegate={delegate => bananinhaDelegate ?? setBananinhaDelegate(delegate)} />
		<Fab
			title="Filtrar"
			aria-label="Filtrar"
			variant="circular"
			color="primary"
			size={fabSize}
			onClick={toggleDrawer('right', true)}
			sx={props.sxFiltrar}
		>
			<FilterAltIcon/>
		</Fab>
		<StyledDrawerFilters anchor={drawerPosition} open={state[drawerPosition]} onClose={toggleDrawer(drawerPosition, false)} transitionDuration={500}>
			<Box padding={2}>
				<Grid container spacing={2} component={'form'} id="FormularioFilter" onSubmit={handleSubmit(onSubmit, onInvalid)}>
					<Grid item xs={12} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
						<Typography component={'h2'} typography={'hb3'}>Filtrar por:</Typography>
						<Button variant='text' color='primary' startIcon={<ClearIcon />} onClick={() => {props.callback({})}} size='small'>Limpar filtros</Button>
					</Grid>
					<Grid item xs={12}>
						<StyledPaperFiltros variant='outlined'>
							<Box padding={2}>
								<Grid container spacing={2}>
									{
									props.filterList.map((filter,keyFilter) =>
										<Grid item key={keyFilter} xs={12}>
											{
											filter == 'idGenero' ?
												<>
												{ generosList &&
													<Controller
														name={filter}
														control={control}
														render={({ field }) => (
															<Autocomplete
																id="genero-autocomplete"
																fullWidth
																size="small"
																autoHighlight
																options={generosList || []}
																getOptionLabel={(option) => option.nome}
																value={generosList.find((genero:any) => genero.idGenero === field.value) || null}
																onChange={(_, selectedOption) => {
																	const selectedValue:any = selectedOption ? selectedOption.idGenero : null;
																	field.onChange(selectedValue);
																}}
																renderOption={(props, option, { inputValue }) => {
																	const matches = match(option.nome, inputValue, { insideWords: true });
																	const parts = parse(option.nome, matches);						
																	return (
																		<li {...props}>
																			<div>
																				{parts.map((part, index) => ( <span key={index} style={{ fontWeight: part.highlight ? 500 : "inherit" }}>{part.text}</span> ))}
																			</div>
																		</li>
																	);
																}}
																renderInput={(params) => (
																	<TextField
																		{...params}
																		label="Gênero"
																		variant="outlined"
																		fullWidth
																	/>
																)}
															/>
														)}
													/>
												}
												</>
											: filter == 'idSerie' ?
												<>
												{ seriesList && (
													<Controller
														name={filter}
														control={control}
														render={({ field }) => (
															<Autocomplete
																id="serie-autocomplete"
																fullWidth
																size="small"
																autoHighlight
																options={seriesList || []}
																getOptionLabel={(option) => `${option.titulo} (ID ${option.idSerie})`}
																value={seriesList.find((serie:any) => serie.idSerie === field.value) || null}
																onChange={(_, selectedOption) => {
																	const selectedValue:any = selectedOption ? selectedOption.idSerie : null;
																	field.onChange(selectedValue);
																}}
																renderOption={(props, option, { inputValue }) => {
																	const matches = match(option.titulo, inputValue, { insideWords: true });
																	const parts = parse(`${option.titulo} (ID ${option.idSerie})`, matches);
																	return (
																		<li {...props}>
																			<div>
																				{
																					parts.map((part, index) => (
																						<span key={index} style={{ fontWeight: part.highlight ? 500 : "inherit" }}>
																							{part.text}</span>
																					))
																				}
																			</div>
																		</li>
																	);
																}}
																renderInput={(params) => (
																	<TextField
																		{...params}
																		label="Série (digite 2 caracteres)"
																		variant="outlined"
																		fullWidth
																	/>
																)}
																filterOptions={filterSeriesOptions}
															/>
														)}
													/>)
												}
												</>
											: filter == 'tipoSerie' ?
												<>
													{
														listOptionsTipoSeries &&
															<Controller
															name="tipoSerie"
															control={control}
															render={({ field }) => (
																<TextField
																	{...field}
																	select
																	id="tipoSerie"
																	label="Tipo de série"
																	fullWidth
																	size="small"
																	value={field.value}
																>
																	<MenuItem value="" sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																	{
																		listOptionsTipoSeries.map((option:IOptions,tipoSerieKey) =>
																			<MenuItem value={option.value} key={tipoSerieKey}>{option.name}</MenuItem>
																		)
																	}
																</TextField>
															)}
														/>
													}
												</>
											: filter == 'idProdutora' ?
												<>
													{
														produtorasList &&
															<Controller
																name={filter}
																control={control}
																render={({ field }) => (
																	<Autocomplete
																		id="produtora-autocomplete"
																		fullWidth
																		size="small"
																		autoHighlight
																		options={produtorasList || []}
																		getOptionLabel={(option) => option.nome}
																		value={produtorasList.find((produtora:any) => produtora.idProdutora === field.value) || null}
																		onChange={(_, selectedOption) => {
																			const selectedValue:any = selectedOption ? selectedOption.idProdutora : null;
																			field.onChange(selectedValue);
																		}}
																		renderOption={(props, option, { inputValue }) => {
																			const matches = match(option.nome, inputValue, { insideWords: true });
																			const parts = parse(option.nome, matches);						
																			return (
																				<li {...props}>
																					<div>
																						{parts.map((part, index) => ( <span key={index} style={{ fontWeight: part.highlight ? 500 : "inherit" }}>{part.text}</span> ))}
																					</div>
																				</li>
																			);
																		}}
																		renderInput={(params) => (
																			<TextField
																				{...params}
																				label="Produtora"
																				variant="outlined"
																				fullWidth
																			/>
																		)}
																	/>
																)}
															/>
													}
												</>
											: filter == 'classificacaoEtaria' ?
												<>
													{
														listOptionsClassEtaria &&
															<Controller
															name="classificacaoEtaria"
															control={control}
															render={({ field }) => (
																<TextField
																	{...field}
																	select
																	id="classificacaoEtaria"
																	label="Classificação etária"
																	fullWidth
																	size="small"
																	value={field.value}
																>
																	<MenuItem value="" sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																	{
																		listOptionsClassEtaria.map((option:IOptions,tipoSerieKey) =>
																			<MenuItem value={option.value} key={tipoSerieKey}>{option.name}</MenuItem>
																		)
																	}
																</TextField>
															)}
														/>
													}
												</>
											: filter == 'tipoPrograma' ?
												<>
													{
														listOptionsTipoPrograma &&
															<Controller
																name="tipoPrograma"
																control={control}
																render={({ field }) => (
																	<TextField
																		{...field}
																		id="tipoPrograma"
																		select
																		label="Tipo de programa"
																		fullWidth
																		size="small"
																		value={field.value}
																	>
																		<MenuItem value="" sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																		{
																			listOptionsTipoPrograma.map((item:IOptions,keyItem) =>
																				<MenuItem value={item.value} key={keyItem}>{item.name}</MenuItem>
																			)
																		}
																	</TextField>
																)}
															/>
													}
												</>
											: filter == 'tipoMidia' ?
												<>
													{
														listOptionsTipoMidia &&
															<Controller
																name="tipoMidia"
																control={control}
																render={({ field }) => (
																	<TextField
																		{...field}
																		select
																		label="Tipo de mídia"
																		fullWidth
																		size="small"
																		value={field.value}
																	>
																		<MenuItem value="" sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																		{
																			listOptionsTipoMidia.map((item:IOptions,keyItem) =>
																				<MenuItem value={item.value} key={keyItem}>{item.name}</MenuItem>
																			)
																		}
																	</TextField>
																)}
															/>
													}
												</>
											: filter == 'vigencia' ?
												<>
													{
														listOptionsVigencia &&
															<Controller
																name="vigencia"
																control={control}
																render={({ field }) => (
																	<TextField
																		{...field}
																		label="Vigência"
																		select
																		fullWidth
																		size="small"
																		value={field.value}
																	>
																		<MenuItem value="" sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																		{
																			listOptionsVigencia.map((item:IOptions,keyItem) =>
																				<MenuItem value={item.value} key={keyItem}>{item.name}</MenuItem>
																			)
																		}
																	</TextField>
																)}
															/>
													}
												</>
											: filter == 'licenciamento' ?
												<>
													{
														listOptionsLicenciamento &&
															<Controller
																name="licenciamento"
																control={control}
																render={({ field }) => (
																	<TextField
																		{...field}
																		select
																		label="Licenciamento"
																		fullWidth
																		size="small"
																		defaultValue={field.value}
																	>
																		<MenuItem value="" sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																		{
																			listOptionsLicenciamento.map((item:IOptions,keyItem) =>
																				<MenuItem value={item.value} key={keyItem}>{item.name}</MenuItem>
																			)
																		}
																	</TextField>
																)}
															/>
													}
												</>
											: filter == 'versao' ?
												<>
													{
														listOptionsVersao &&
															<Controller
																name="versao"
																control={control}
																render={({ field }) => (
																	<TextField
																		{...field}
																		label="Versão"
																		select
																		fullWidth
																		size="small"
																		value={field.value}
																	>
																		<MenuItem value="" sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																		{
																			listOptionsVersao.map((item:IOptions,keyItem) =>
																				<MenuItem value={item.value} key={keyItem}>{item.name}</MenuItem>
																			)
																		}
																	</TextField>
																)}
															/>
													}
												</>
											: filter == 'idiomaVersao' ?
												<>
													{
														listOptionsIdioma &&
															<Controller
																name="idiomaVersao"
																control={control}
																render={({ field }) => (
																	<TextField
																		{...field}
																		label="Idioma da versão"
																		select
																		fullWidth
																		size="small"
																		value={field.value}
																	>
																		<MenuItem value="" sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																		{
																			listOptionsIdioma.map((item:IOptions,keyItem) =>
																				<MenuItem value={item.value} key={keyItem}>{item.name}</MenuItem>
																			)
																		}
																	</TextField>
																)}
															/>
													}
												</>
											: filter == 'anoProducao' ?
												<Grid container spacing={2}>
													<Grid item xs={12} xm={6}>
														<Controller
															name="anoProducaoInicial"
															control={control}
															rules={{
																// required: validacao.requerido,
																// minLength: { value:2, message:`${validacao.minLength} 2`, },
																maxLength: { value: 4, message:`${validacao.maxLength} 4`, }
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	inputProps={{maxLength:4}}
																	label={'Ano Produção Inicial'}
																	fullWidth
																	value={field.value || ''}
																	error={!!errors[filter]}
																	helperText={errors[filter] ? errors[filter].message as string : null}
																	size='small'
																/>
															)}
														/>
													</Grid>
													<Grid item xs={12} xm={6}>
														<Controller
															name="anoProducaoFinal"
															control={control}
															rules={{
																// required: validacao.requerido,
																// minLength: { value:2, message:`${validacao.minLength} 2`, },
																maxLength: { value: 4, message:`${validacao.maxLength} 4`, }
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	inputProps={{maxLength:4}}
																	label={'Ano Produção Final'}
																	fullWidth
																	value={field.value || ''}
																	error={!!errors[filter]}
																	helperText={errors[filter] ? errors[filter].message as string : null}
																	size='small'
																/>
															)}
														/>
													</Grid>
												</Grid>
											:
												<Controller
													name={filter as any}
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:2, message:`${validacao.minLength} 2`, },
														maxLength: { value:100, message:`${validacao.maxLength} 100`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															inputProps={{maxLength:100}}
															label={filterNames(filter)}
															fullWidth
															value={field.value || ''}
															error={!!errors[filter]}
															helperText={errors[filter] ? errors[filter].message as string : null}
															size='small'
														/>
													)}
												/>
											}
										</Grid>
									)}
								</Grid>
							</Box>
						</StyledPaperFiltros>
					</Grid>
					<Grid item xs={12}>
						<Button type="submit" color="primary" size="large" variant="contained" startIcon={<SearchIcon />} fullWidth title="Buscar" aria-label="Buscar">Buscar</Button>
					</Grid>
				</Grid>
			</Box>
		</StyledDrawerFilters>
	</>
}

const StyledDrawerFilters = styled(Drawer)(({ theme }) => (
{
	"& .MuiDrawer-paper": {
		maxWidth:"min(80%, 500px)",
		paddingTop:"60px"
	},
}));

const StyledPaperFiltros = styled(Paper)({
	maxHeight: "calc(100vh - 200px)",
	overflowY: 'scroll'
});

export default TableFilter;

function filterNames(item:string)
{
	switch(item)
	{
		case "titulo":          	return "Título";                  	break;
		case "nome":          		return "Nome";                  	break;
		case "anoProducao":    	 	return "Ano da produção";       	break;
		case "anoProducaoInicial":	return "Ano da produção (Inicial)";	break;
		case "anoProducaoFinal":	return "Ano da produção (Final)";	break;
		case "idGenero":        	return "Gênero";                break;
		case "numeroCpb":       	return "Número CPB";            break;
		case "numeroCrt":       	return "Número CRT";            break;
		case "idGsatIdFrm":     	return "ID GSAT/FRM";           break;
		case "idSerie":         	return "Série";                 break;
		case "displayName":     	return "Nome";                  break;
		case "email":           	return "E-mail";                break;
		case "tipoSerie":  			return "Tipo de série";    		break;
		case "produtora":  			return "Produtora";    			break;
		case "idProdutora":  		return "Produtora";    			break;
		case "classificacaoEtaria": return "Classificação etária";	break;
		case "tipoPrograma":  		return "Tipo de programa";		break;
		case "tipoMidia":  			return "Tipo de Mídia";			break;
		case "numeroEpisodio":  	return "Número do episódio";   	break;
		case "vigencia":  			return "Vigência";    			break;
		case "licenciamento":  		return "Licenciamento";    		break;
		case "versao":  			return "Versão";    			break;
		case "idiomaVersao":  		return "Idioma da versão"; 		break;
		case "sinopseSerie":  		return "Sinopse";		 		break;
		case "elenco":  			return "Elenco";		 		break;
		case "sinopse":  			return "Sinopse";		 		break;
		case "sinopseIdioma":  		return "Sinopse Idioma";		break;
		case "palavraChave":  		return "Palavra-chave";			break;
	}
}